module.exports = __webpack_public_path__ + "static/media/chart-horizontal-bar.6c96b3e8.svg";